import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import DropZone from 'react-dropzone';
import {FormattedMessage} from 'react-intl';
import {withFirebase} from 'react-redux-firebase';

import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';

import CloseIcon from '@material-ui/icons/Close';

import Loading from '../../common/Loading';

import firebaseUtils from '../../../util/FirebaseUtils';

class FileDrop extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.clearImage = this.clearImage.bind(this);
        this.generateComponent = this.generateComponent.bind(this);
        this.getImage = this.getImage.bind(this);
        this.handleOnDrop = this.handleOnDrop.bind(this);

        this.state = {
            imageUrl: null,
            initialized: false,
            uploading: false
        };
    }

    clearImage(event, onChange) {
        event.stopPropagation();
        onChange(null);
        this.setState({imageUrl: null});
    }

    generateComponent(props, imageUrl) {
        const {clearable, disabled, field, input, label, messageId, meta: {active, error, warning, touched, dirty}, uploading, ...rest} = props;

        if (!this.state.initialized && input.value) {
            this.getImage(input.value);
        }

        return (
            <FormControl disabled={disabled} fullWidth>
                <InputLabel htmlFor={field} className="drop-zone-label" shrink>
                    {messageId ? <FormattedMessage id={messageId}/> : label}
                </InputLabel>
                <Paper className="drop-zone-wrapper">
                    <DropZone
                        onDrop={(files) => this.handleOnDrop(files, input.onChange)}
                        className="drop-zone"
                        {...rest}
                    >
                        {do {
                            if (clearable && input.value) {
                                <IconButton
                                    className="drop-zone-clear"
                                    onClick={e => this.clearImage(e, input.onChange)}
                                >
                                    <CloseIcon/>
                                </IconButton>;
                            }
                        }}
                        {do {
                            if (uploading) {
                                <Loading small/>;
                            } else if (imageUrl) {
                                <img className="image-preview" src={imageUrl} alt="preview"/>;
                            } else {
                                <FormattedMessage id="forms.fileDrop.dropHere"/>;
                            }
                        }}
                    </DropZone>
                </Paper>
                <FormHelperText error={!!error ? !!error : undefined}>
                    {do {
                        if ((dirty || touched) && !!error) {
                            error;
                        } else if (active && (dirty || touched) && !error && !!warning) {
                            warning;
                        }
                    }}
                </FormHelperText>
            </FormControl>
        );
    }

    getImage(path) {
        firebaseUtils.getImageUrl(this.props.firebase, path)
            .then(url => {
                this.setState({
                    imageUrl: url ? url : null,
                    initialized: true
                });
            });
    }

    handleOnDrop(files, onChange) {
        this.setState({imageUrl: null, uploading: true});

        return this.props.onDrop(files, this.props.field)
            .then(url => {
                this.setState({uploading: false});
                this.getImage(url);
                return onChange(url);
            });
    }

    render() {
        const {field, helpButton, label, show, ...rest} = this.props;

        if (show !== undefined && !show) {
            return null;
        }

        return (
            <span className="input">
            <Field
                name={field}
                label={label}
                component={props => this.generateComponent(props, this.state.imageUrl)}
                uploading={this.state.uploading}
                {...rest}
            />
                {helpButton}
        </span>
        );
    };
}

FileDrop.propTypes = {
    field: PropTypes.string.isRequired,
    helpButton: PropTypes.node,
    label: PropTypes.string,
    messageId: PropTypes.string,
    onDrop: PropTypes.func.isRequired
};

export default withFirebase(FileDrop);


// WEBPACK FOOTER //
// ./src/components/common/form/FileDrop.js